import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GeneralHealth from './general-health';
import GeneralHealthDetail from './general-health-detail';
import GeneralHealthUpdate from './general-health-update';
import GeneralHealthDeleteDialog from './general-health-delete-dialog';

const GeneralHealthRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GeneralHealth />} />
    <Route path="new" element={<GeneralHealthUpdate />} />
    <Route path=":id">
      <Route index element={<GeneralHealthDetail />} />
      <Route path="edit" element={<GeneralHealthUpdate />} />
      <Route path="delete" element={<GeneralHealthDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GeneralHealthRoutes;
